import { useQuery } from '@tanstack/react-query';

import type { MakeupBooking } from '~entities/makeup/api/book-makeup';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const getMakeupsByClassDateAPI = async (params: {
  enrollmentId: string;
  date: string;
}) => {
  const response = await baseAPI.get<Array<MakeupBooking>>('/makeup', {
    params,
  });
  return response.data;
};

export const useGetMakeupsByClassDate = (
  params: { enrollmentId: string; date: string },
  enabled = true,
) => {
  return useQuery({
    queryKey: [
      KEYS.MAKEUP_BY_CLASS_DATE,
      params.enrollmentId,
      params.date,
    ],
    queryFn: () => getMakeupsByClassDateAPI(params),
    enabled: enabled && !!params.enrollmentId && !!params.date,
  });
};
